export const ORDER_MENU_LOADING = 'REDUX_SAGA_ORDER_MENU_LOADING';
export const ORDER_MENU_SUCCESS = 'REDUX_SAGA_ORDER_MENU_SUCCESS';
export const ORDER_MENU_ERROR = 'REDUX_SAGA_ORDER_MENU_ERROR';

export const actionGetOrderMenuByDisplayArea = (dispatch, displayArea) => {
    dispatch({ type: ORDER_MENU_LOADING, payload: displayArea })
};